import * as types from "./actionTypes"

export function fetchShipperTrackDetailsSuccess(data) {
    return {
        type: types.VISIBILITY_SHIPMENT_LIST_FETCH_SUCCESS,
        payload: data,
    }
}

export function fetchShippmentsSuccess(data) {
    return {
        type: types.VISIBILITY_SHIPPER_TRACK_DETAILS_FETCH_SUCCESS,
        payload: data,
    }
}

export function fetchShippmentFilterValues(data) {
    return {
        type: types.VISIBILITY_SHIPPER_FILTER_VALUES_FETCH,
        payload: data,
    }
}
export function fetchShippmentFilterValuesSuccess(data) {
    return {
        type: types.VISIBILITY_SHIPPER_FILTER_VALUES_FETCH_SUCCESS,
        payload: data,
    }
}

export function fetchShippmentFilterValuesFailure() {
    return {
        type: types.VISIBILITY_SHIPPER_FILTER_VALUES_FETCH_FAILURE,
    }
}

export function fetchComments(data) {
    return {
        type: types.VISIBILITY_FETCH_COMMENTS,
        payload: { data },
    }
}

export function fetchCommentsSuccess(data) {
    return {
        type: types.VISIBILITY_FETCH_COMMENTS_SUCCESS,
        payload: data,
    }
}
export function postComment(data) {
    return {
        type: types.VISIBILITY_POST_COMMENT,
        payload: data,
    }
}
export function postCommentSuccess(data) {
    return {
        type: types.VISIBILITY_POST_COMMENT_SUCCESS,
        payload: data,
    }
}

export function fetchRejectReasons(data) {
    return {
        type: types.VISIBILITY_REJECT_REASONS_FETCH,
        payload: data,
    }
}

export function fetchRejectReasonsSuccess(data) {
    return {
        type: types.VISIBILITY_REJECT_REASONS_FETCH_SUCCESS,
        payload: data,
    }
}

export function fetchWayBillInformation(data) {
    return {
        type: types.VISIBILITY_WAYBILL_INFORMATION_FETCH,
        payload: data,
    }
}

export function fetchWayBillInformationSuccess(data) {
    return {
        type: types.VISIBILITY_WAYBILL_INFORMATION_FETCH_SUCCESS,
        payload: data,
    }
}

export function fetchRailcarMovements(data) {
    return {
        type: types.VISIBILITY_RAILCAR_MOVEMENTS_FETCH,
        payload: data,
    }
}

export function fetchRailcarMovementsSuccess(data) {
    return {
        type: types.VISIBILITY_RAILCAR_MOVEMENTS_FETCH_SUCCESS,
        payload: data,
    }
}

export function getCarSchedulingRailcarMovements(details) {
    return {
        type: types.VISIBILITY_GET_CAR_SCHEDULING_RAILCAR_MOVEMENTS,
        payload: details,
    }
}

export function getCarSchedulingRailcarMovementsSuccess(data) {
    return {
        type: types.VISIBILITY_GET_CAR_SCHEDULING_RAILCAR_MOVEMENTS_SUCCESS,
        payload: data,
    }
}
export function fetchShipmentWaybill(data) {
    return {
        type: types.VISIBILITY_SHIPMENT_WAYBILL_FETCH,
        payload: data,
    }
}

export function fetchShipmentWaybillSuccess(data) {
    return {
        type: types.VISIBILITY_SHIPMENT_WAYBILL_FETCH_SUCCESS,
        payload: data,
    }
}

export function clearWayBill() {
    return {
        type: types.VISIBILITY_CLEAR_WAYBILL,
    }
}

export function saveActionCode(data) {
    return {
        type: types.VISIBILITY_SAVE_ACTION_CODE,
        payload: data,
    }
}

export function saveActionCodeSuccess(data) {
    return {
        type: types.VISIBILITY_SAVE_ACTION_CODE_SUCCESS,
        payload: data,
    }
}

export function lazyLoadPageInfoAction({ page = 0, size = 20 }) {
    return {
        type: types.LAZY_LOAD_SHIPMENTS_PAGEINFO,
        payload: { page: page, size: size },
    }
}

export function clearSelectedEquipments() {
    return {
        type: types.CLEAR_SELECTED_EQUIPMENTS,
    }
}
export function updateSelectedEquipments(data) {
    return {
        type: types.UPDATE_SELECTED_EQUIPMENTS,
        payload: data,
    }
}

export function setExtractionDate(data) {
    return {
        type: types.SET_EXTRACTION_DATE,
        payload: data,
    }
}
export function setExtractionNumber(data) {
    return {
        type: types.SET_EXTRACTION_NUMBER,
        payload: data,
    }
}

export function setPagingInformation(data) {
    return {
        type: types.SHIPMENTS_PAGEINFO,
        payload: data,
    }
}

export function getEbolToken() {
    return {
        type: types.VISIBILITY_GET_EBOL_TOKEN,
    }
}

export function getEbolTokenSuccess(data) {
    return {
        type: types.VISIBILITY_GET_EBOL_TOKEN_SUCCESS,
        payload: data,
    }
}
export function getEbolTokenFailure(data) {
    return {
        type: types.VISIBILITY_GET_EBOL_TOKEN_FAILURE,
        payload: data,
    }
}

export function selectCarsInActions(data) {
    return {
        type: types.SELECT_CARS_IN_ACTIONS,
        payload: data,
    }
}

export function clearVisibilityAll() {
    return {
        type: types.CLEAR_VISIBILITY_ALL,
    }
}

export function setRailroadDate(data) {
    return {
        type: types.SET_RAILROAD_DATE,
        payload: data,
    }
}

export function fetchTelegraphData(shipments) {
    return {
        type: types.PLATFORM_SERVICE_FETCH,
        payload: shipments,
    }
}

export function fetchTelegraphDataSucess(data) {
    return {
        type: types.PLATFORM_SERVICE_FETCH_SUCCESS,
        payload: data,
    }
}

export function fetchTelegraphDataFailure(error) {
    return {
        type: types.PLATFORM_SERVICE_FETCH_FAILURE,
        payload: error,
    }
}

export function fetchTelegraphDataClear() {
    return {
        type: types.PLATFORM_SERVICE_FETCH_CLEAR,
    }
}

export function setDateRangeTMS(range) {
    return {
        type: types.SEET_DATE_RANGE_TMS,
        payload: range,
    }
}

export function setDateRangeTELEGRAPH(data) {
    return {
        type: types.SEET_DATE_RANGE_TELEGRAPH,
        payload: data,
    }
}
